/**
 * @module BN3THMobileMenu
 * @description Singleton that manages the mobile navigation drawer.
 * Wired to [data-js-mobile-menu-trigger] in the header and
 * [data-js-mobile-menu] on the main div in bn3th-mobile-menu.liquid.
 */
const BN3THMobileMenu = (() => {
  const LOGGING = true;

  const SETTINGS = {
    name: "bn3th-mobile-menu.js",
  };

  const SELECTORS = {
    trigger: "[data-js-mobile-menu-trigger]",
    menu: "[data-js-mobile-menu]",
  };

  let el = {};
  let isOpen = false;
  let initialized = false;

  const open = () => {
    el.menu.setAttribute("data-open", "");
    el.menu.setAttribute("aria-hidden", "false");
    el.trigger.setAttribute("aria-expanded", "true");
    el.trigger.classList.add("bn3th-header__burger--open");
    document.body.classList.add("mobile-menu--open");
    document.addEventListener("keydown", onKeydown);
    isOpen = true;
    LOGGING && console.log(`[${SETTINGS.name}] :: open()`);
  };

  const close = () => {
    el.menu.removeAttribute("data-open");
    el.menu.setAttribute("aria-hidden", "true");
    el.trigger.setAttribute("aria-expanded", "false");
    el.trigger.classList.remove("bn3th-header__burger--open");
    document.body.classList.remove("mobile-menu--open");
    document.removeEventListener("keydown", onKeydown);
    isOpen = false;
    LOGGING && console.log(`[${SETTINGS.name}] :: close()`);
  };

  const toggle = () => (isOpen ? close() : open());

  const onKeydown = (e) => {
    if (e.key === "Escape") close();
  };

  const init = () => {
    if (initialized || !document.querySelector(SELECTORS.trigger)) return;
    LOGGING && console.log(`[${SETTINGS.name}] :: Start`);

    el = {
      trigger: document.querySelector(SELECTORS.trigger),
      menu: document.querySelector(SELECTORS.menu),
    };

    if (!el.trigger || !el.menu) {
      LOGGING &&
        console.warn(`[${SETTINGS.name}] :: Required elements not found.`);
      return;
    }

    el.trigger.setAttribute("aria-expanded", "false");
    initialized = true;
    el.trigger.setAttribute("aria-controls", el.menu.id || "bn3th-mobile-menu");

    el.trigger.addEventListener("click", (e) => {
      e.preventDefault();
      toggle();
    });

    LOGGING && console.log(`[${SETTINGS.name}] :: Complete`);
  };

  return { init, open, close };
})();

document.addEventListener(
  "bn3th:navigation:modern-ready",
  BN3THMobileMenu.init,
);
BN3THMobileMenu.init();

// Mobile search lives in a <bn3th-slide-panel> (bn3th-search-panel.liquid),
// which owns its own open/close/trigger/Escape/outside-click. externalPanel:
// true tells this instance to skip managing those itself (no trigger/close
// selectors needed here, the panel's own [data-trigger-selector]/[data-close]
// handle that) and just react to the panel's open/close via its events.
let mobileSearch;
const initMobileSearch = () => {
  const mobileSearchPanel = document.querySelector(
    "[data-js-mobile-search-overlay]",
  );
  if (mobileSearch || !mobileSearchPanel) return;
  mobileSearch = BN3THSearch.create({ externalPanel: true });
  mobileSearch.init({
    overlay: "[data-js-mobile-search-overlay]",
    input: "[data-js-mobile-search-input]",
    panel: "[data-js-mobile-search-panel]",
    results: "[data-js-mobile-search-results]",
  });
  mobileSearchPanel.addEventListener("slidepanel:open", () =>
    mobileSearch.open(),
  );
  mobileSearchPanel.addEventListener("slidepanel:close", () =>
    mobileSearch.close(),
  );
};
document.addEventListener("bn3th:navigation:modern-ready", initMobileSearch);
initMobileSearch();
